import React, { useEffect } from "react";

import { wrap } from "./RydTestbedWrap";
import { SamplesBrowser } from "../components/dialogs/browsers/SamplesBrowser";
import {
    readMidiFileAsHNCs,
    RydBasicTrackMetadata
} from "../utils/RydMidiConverter";
import { Midi } from "@tonejs/midi";
import PianoRoll from "../components/rolls/PianoRoll";
import {
    MetronomeMarking,
    NoteDuration,
    TimeSignature
} from "../model/core";
import { RydProject } from "../model/project";


export function SampleNavigatorTestbed() {

    const [parsedMidi, setParsedMidi] = React.useState<RydBasicTrackMetadata[]>();
    // const zoomStore = useZoomStore();
    // useEffect(() => {
    //     if (!parsedMidi || parsedMidi.length === 0) return;
    //     console.log('Setting zoom factor based on parsed MIDI PPQ:', parsedMidi[0].hnc.getPPQ());
    //     zoomStore.setZoomFactor(480);
    // }, [parsedMidi]);

    return wrap(<>
        {/* Add your testbed components here */}
        <h1>SampleNavigator2 Testbed</h1>

        <SamplesBrowser
            className="interaction-panel"
            style={{ maxHeight: '400px', width: '360px', fontSize: '8pt' }}
            includeMetadata
            onSelectFile={(file, adapter) => {
                console.log('Selected file:', file.path);
                adapter.readFile(file.path, 'arrayBuffer').then((data) => {
                    console.log('File data (ArrayBuffer):', data);
                    if (!(data instanceof ArrayBuffer)) {
                        console.error('Data is not an ArrayBuffer', data);
                        return;
                    }
                    const midi = new Midi(data);
                    const hncs: RydBasicTrackMetadata[] = readMidiFileAsHNCs(midi);
                    console.log('Parsed MIDI:', hncs);
                    setParsedMidi(hncs);

                }).catch((err) => {
                    console.error('Error reading file:', err);
                });
            }}
        />

        {parsedMidi && parsedMidi.length > 0 && (
            <div style={{ marginTop: '20px' }}>
                <h2>Parsed MIDI Piano Roll</h2>
                {parsedMidi.map((tmd: RydBasicTrackMetadata, index: number) => (
                    <div key={index} style={{ marginBottom: '40px' }}>
                        <h3>Track {index + 1}: {tmd.trackName}</h3>
                        <PianoRoll
                            project={RydProject.createForNewProject('Test Project')}
                            hnc={tmd.hnc}
                            track={{
                                name: tmd.trackName,
                                color: "#ff0000",
                                id: index,
                                length: tmd.hnc.getLength(),
                                sequence: tmd.hnc,
                                bookmarks: [],
                            }}
                            setTrack={() => { }}
                            setTrackUIState={(x) => { }}
                            uiState={{
                                trackId: index,
                                collapsed: false,
                                noteRange: { min: 21, max: 108 },
                                tonalityVisible: false,
                                color: "#ff0000",
                            }}
                            contextFrame={{
                                metronome: new MetronomeMarking(120, new NoteDuration(4)),
                                timeSignature: new TimeSignature(4, 4),
                            }}
                            readonly={false}
                            mode="track"
                        />
                    </div>
                ))}
            </div>
        )}

    </>);
}